"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceiptGenericClass = exports.ReceiptGeneric = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.ReceiptGeneric = typebox_1.Type.Object({
    invoice_number: typebox_1.Type.String(),
    invoice_amount: typebox_1.Type.String(),
    first_name: typebox_1.Type.String(),
    custom_message: typebox_1.Type.Optional(typebox_1.Type.String()),
});
class ReceiptGenericClass {
    first_name;
    invoice_number;
    custom_message;
    invoice_amount;
    constructor(data) {
        this.first_name = data.first_name;
        this.invoice_number = data.invoice_number;
        this.invoice_amount = data.invoice_amount;
        this.custom_message = data.custom_message;
    }
}
exports.ReceiptGenericClass = ReceiptGenericClass;
//# sourceMappingURL=receipt-generic.js.map